export default __webpack_public_path__ + "static/orientation-ad35e39ad10b24fab8c3745f692009e6.png";